<div class="w-full h-full flex-1 min-h-0">
    <ag-grid-angular
        class="w-full h-full"
        [gridOptions]="gridOptions"
        [columnDefs]="columnDefs"
        [rowData]="items()"
        [loading]="loading()"
        [overlayNoRowsTemplate]="noRowsTemplate"
        (gridReady)="onGridReady($event)"
        (bodyScroll)="onBodyScroll($event)"
    />
</div>
